import cssVariables from './variables';
import commonStyles from './common';

export default {
  pageTitle: {
    fontSize: cssVariables['--page-title-font-size'],
    fontFamily: cssVariables['--primary-font-header-bold'],
    color: cssVariables['--secondary-color-5'],
  },

  pageSubtitle: {
    fontSize: cssVariables['--secondary-font-size'],
    color: cssVariables['--secondary-color-3'],
  },

  // Form inputs
  // Specific to MUI TextFields
  textField: {
    fontSize: cssVariables['--form-item-font-size'],
    height: cssVariables['--form-item-height'],
    width: '100%',
    transition: 'all 450ms linear 0',
    backgroundColor: cssVariables['--modal-input-color'],
  },
  textFieldFocused: {
    outline: 'none',
    border: commonStyles.border,
  },
  textFieldHint: {
    color: cssVariables['--secondary-color-6'],
    fontFamily: cssVariables['--primary-font'],
    bottom: 'initial',
    padding: '0 0 0 12px',
    ...commonStyles.verticalAlignChild,
  },
  textFieldInput: {
    padding: '0 0 0 12px',
    color: cssVariables['--secondary-color-5'],
  },
  textFieldInputBold: {
    fontFamily: cssVariables['--primary-font-med'],
  },
  errorState: {
    border: `1px solid ${cssVariables['--error-color']}`,
  },
  inlineError: {
    fontFamily: cssVariables['--primary-font-thin'],
    color: cssVariables['--error-color-light'],
    top: 0,
    lineHeight: '13px',
    fontSize: 12,
    paddingTop: 5,
  },
  label: {
    top: 9,
    left: 10,
    fontSize: 17,
  },
  floatingLabelShrink: {
    top: 2,
    left: 0,
    fontSize: 17,
  },
  disabledState: {
    color: cssVariables['--dark-sub-text'],
    backgroundColor: cssVariables['--tunein-gray'],
  },
};
